import {
  Icon3dCubeSphere,
  IconApps,
  IconBan,
  IconBasket,
  IconBrandAsana,
  IconCertificate,
  IconKey,
  IconReportMoney,
  IconUserCheck,
  IconUsers,
} from "@tabler/icons";

import { PathKeys, UserRole } from "@sso/constant";
import { DrawerGroupType } from "@sso/types";

//access property are optional in the DrawerGroupType
//We assume all menus are public. So, don't add access for public role
//If a menu wants user to be administrator add the access like management one on the below.

const products: DrawerGroupType = {
  id: "products",
  title: "Products",
  children: [
    {
      id: "products",
      title: "Products",
      url: PathKeys.ROOT,
      icon: IconApps,
    },
  ],
};

const profile: DrawerGroupType = {
  id: "profile",
  title: "Profile",
  children: [
    {
      id: "edit-profile",
      title: "Edit Profile",
      url: PathKeys.EDIT_PROFILE,
      icon: IconUserCheck,
    },
    {
      id: "change-password",
      title: "Change Password",
      url: PathKeys.CHANGE_PASSWORD,
      icon: IconKey,
    },
  ],
};

const management: DrawerGroupType = {
  id: "management",
  title: "Management",
  access: [UserRole.ADMINISTRATOR, UserRole.ORG_ADMIN, UserRole.PUBLIC],
  children: [
    {
      id: "organisations",
      title: "Organisations",
      url: PathKeys.ORGANISATIONS,
      icon: IconBrandAsana,
      access: [UserRole.ADMINISTRATOR],
    },
    {
      id: "users",
      title: "Users",
      url: PathKeys.USERS,
      icon: IconUsers,
      access: [UserRole.ADMINISTRATOR, UserRole.ORG_ADMIN],
    },
    {
      id: "licences",
      title: "Licences",
      url: PathKeys.LICENCES,
      icon: IconCertificate,
      access: [UserRole.ADMINISTRATOR, UserRole.ORG_ADMIN, UserRole.PUBLIC],
    },
    {
      id: "billedOperations",
      title: "Billing",
      url: PathKeys.BILLED_OPERATIONS,
      icon: IconReportMoney,
      access: [UserRole.ADMINISTRATOR, UserRole.ORG_ADMIN],
    },
    {
      id: "billedOperationsSummary",
      title: "Billing Summary",
      url: PathKeys.BILLED_OPERATION_SUMMARY,
      icon: IconReportMoney,
      access: [UserRole.ADMINISTRATOR],
    },
    {
      id: "apiAccounts",
      title: "API Accounts",
      url: PathKeys.API_ACCOUNTS,
      icon: Icon3dCubeSphere,
      access: [UserRole.ADMINISTRATOR, UserRole.ORG_ADMIN],
    },
    {
      id: "bannedIp",
      title: "Banned IP",
      url: PathKeys.BANNED_IP,
      icon: IconBan,
      access: [UserRole.ADMINISTRATOR],
    },
    {
      id: "product-licences",
      title: "Products",
      url: PathKeys.PRODUCT_LICENCES,
      icon: IconApps,
      access: [UserRole.ADMINISTRATOR],
    },
    {
      id: "orders",
      title: "Orders",
      url: PathKeys.ORDERS,
      icon: IconBasket,
      access: [],
    },
  ],
};

const sales: DrawerGroupType = {
  id: "sales",
  title: "Sales",
  access: [UserRole.ADMINISTRATOR],
  children: [
    {
      id: "traccUsage",
      title: "TRACC Usage",
      url: PathKeys.TRACC_USAGE,
      icon: IconBrandAsana,
      access: [UserRole.ADMINISTRATOR],
    },
  ],
};

export const drawerItems = [products, management, sales, profile];
